const TIME = 'TIME'
const DISTANCE = 'DISTANCE'

export default Object.freeze({
    TIME,
    DISTANCE,
})
